document.addEventListener('DOMContentLoaded', () => {
  const emblaNode = document.querySelector('#testimonial-carousel');
  if (!emblaNode) return;

  const sliders = emblaNode.querySelectorAll('.before-after-slider');
  let userHasInteracted = false;
  let syncDebounceTimer;

  const debouncedAnimationSync = (api) => {
    clearTimeout(syncDebounceTimer);
    syncDebounceTimer = setTimeout(() => {
      if (userHasInteracted) return;
      
      const visibleIndexes = api.slidesInView();
      const allSlides = api.slideNodes();

      allSlides.forEach(slide => {
        const sliderInSlide = slide.querySelector('.before-after-slider');
        if (sliderInSlide) sliderInSlide.classList.remove('animating');
      });

      requestAnimationFrame(() => {
        allSlides.forEach((slide, index) => {
          if (visibleIndexes.includes(index)) {
            const sliderInSlide = slide.querySelector('.before-after-slider');
            if (sliderInSlide) sliderInSlide.classList.add('animating');
          }
        });
      });
    }, 50);
  };
  
  const haltAutomaticAnimations = () => {
    if (userHasInteracted) return;
    userHasInteracted = true;
    sliders.forEach(s => s.classList.remove('animating'));
  };

  sliders.forEach(slider => {
    let isDragging = false;
    const beforeImageContainer = slider.querySelector('.before-image-container');
    const handle = slider.querySelector('.slider-handle');

    const moveSlider = (clientX) => {
      const rect = slider.getBoundingClientRect();
      const x = Math.max(0, Math.min(clientX - rect.left, rect.width));
      const percent = (x / rect.width) * 100;
      beforeImageContainer.style.clipPath = `inset(0 ${100 - percent}% 0 0)`;
      handle.style.left = `calc(${percent}% - 2px)`;
    };
    
    const startDrag = (e) => {
      e.stopPropagation();
      haltAutomaticAnimations();
      isDragging = true;
      slider.classList.add('is-dragging');
      document.body.classList.add('slider-dragging');
      moveSlider(e.clientX || e.touches[0].clientX);
    };

    const stopDrag = () => {
      if (!isDragging) return;
      isDragging = false;
      slider.classList.remove('is-dragging');
      document.body.classList.remove('slider-dragging');
    };

    const onDrag = (e) => {
      if (!isDragging) return;
      moveSlider(e.clientX || e.touches[0].clientX);
    };

    slider.addEventListener('mousedown', startDrag);
    slider.addEventListener('touchstart', startDrag, { passive: true });
    document.addEventListener('mouseup', stopDrag);
    document.addEventListener('touchend', stopDrag);
    document.addEventListener('mousemove', onDrag);
    document.addEventListener('touchmove', onDrag, { passive: true });
  });

  if (typeof EmblaCarousel === 'function') {
    const emblaApi = EmblaCarousel(emblaNode, { loop: true, align: 'start', draggable: true });

    const prevBtn = document.querySelector('#carousel-prev');
    const nextBtn = document.querySelector('#carousel-next');
    const counterNode = document.querySelector('#carousel-counter');

    const updateCounter = () => {
      const slideCount = emblaApi.scrollSnapList().length;
      const currentSlide = emblaApi.selectedScrollSnap() + 1;
      if (counterNode) {
        counterNode.textContent = `Slide ${currentSlide} of ${slideCount}`;
      }
    };
    
    emblaApi.on('select', () => {
      updateCounter();
      debouncedAnimationSync(emblaApi);
    });
    
    emblaApi.on('reInit', () => {
      updateCounter();
      debouncedAnimationSync(emblaApi);
    });

    prevBtn.addEventListener('click', emblaApi.scrollPrev);
    nextBtn.addEventListener('click', emblaApi.scrollNext);

    setTimeout(() => {
      updateCounter();
      debouncedAnimationSync(emblaApi);
    }, 100);
  }

  // --- Read More Logic ---
  document.querySelectorAll('.testimonial-quote').forEach(quote => {
    const wrapper = quote.closest('.testimonial-quote-wrapper');
    const readMoreBtn = wrapper.querySelector('.read-more-btn');
    const MAX_HEIGHT = 120; // Must match the CSS max-height

    if (quote.scrollHeight > MAX_HEIGHT) {
      quote.classList.add('needs-truncation');

      readMoreBtn.addEventListener('click', () => {
        wrapper.classList.add('is-expanded');
        quote.style.maxHeight = quote.scrollHeight + 'px';
      });
    }
  });
}); 